import {
  ENTER_PLACEHOLDER_FIELD_TYPES,
  SELECT_PLACEHOLDER_FIELD_TYPES
} from '@cli-constants/schema-codegen.js'

export function derivePlaceholderFromLabel(type: string, label: string): string | undefined {
  const normalizedLabel = label.trim()
  if (!normalizedLabel) {
    return undefined
  }

  const lowerLabel = normalizedLabel.toLowerCase()
  if (SELECT_PLACEHOLDER_FIELD_TYPES.has(type)) {
    return `Select ${lowerLabel}`
  }

  if (ENTER_PLACEHOLDER_FIELD_TYPES.has(type)) {
    return `Enter ${lowerLabel}`
  }

  return undefined
}
